<template>
  <div
    ref="scrollContainer"
    class="flex overflow-x-scroll disable-scrollbars horizontal-scroll pr-6 md:pr-0 md:justify-between"
    tabindex="0"
    role="region"
    aria-label="Scrollable products"
    @keydown.left="scrollLeft"
    @keydown.right="scrollRight"
  >
    <div
      v-for="(product, i) in products"
      :key="`${product.title}-${i}`"
      class="flex-1 horizontal-scroll-center pr-4"
      :class="{
        'pl-4 md:pl-0': i !== 0,
        'pl-4 md:pl-0': i === 0
      }"
    >
      <div class="rounded flex justify-center">
        <OImage v-bind="product.image" img-class="rounded" />
      </div>
      <p class="pt-4 o-heading-5 text-center mb-6" v-text="product.title" />
      <p class="o-body text-center" v-text="product.description" />
    </div>
  </div>
</template>

<script>
import OImage from '@/components/OImage'

export default {
  name: 'WebshopProductSlider',
  components: { OImage },
  props: {
    products: {
      type: Array,
      default: () => ([]),
      validator: value => value.every(obj => ['image', 'title', 'description'].every(prop => obj.hasOwnProperty(prop)))
    }
  },
  methods: {
    scrollLeft () {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollLeft -= 200 // Adjust scroll amount as needed
      }
    },
    scrollRight () {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollLeft += 200 // Adjust scroll amount as needed
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.oimage >>> img {
  max-width: unset;
}

/* Add visual indication of focus */
.horizontal-scroll:focus {
  outline: 2px solid #36C0B6; /* Use your primary color */
  outline-offset: -2px;
}

/* Add scrollbar styling for visual users */
.horizontal-scroll {
  scroll-behavior: smooth; /* For smooth scrolling */
}
</style>
